import React, {useCallback} from 'react'
import { canUseDOM } from 'fbjs/lib/ExecutionEnvironment'
import { Alert, Linking, StyleSheet, Pressable } from "react-native"


const Link = ({ href, children }) => {
    const onPress = useCallback(async () => {
	// Checking if the link is supported for links with custom HREF scheme.
	const supported = await Linking.canOpenURL(href);
	if (supported) {
	    // Opening the link with some app, if the HREF scheme is "http" the web link should be opened
	    // by some browser in the mobile
            if (canUseDOM)
                return window.open(href, '_blank')
	    await Linking.openURL(href)
	} else {
	    Alert.alert(`Don't know how to open this HREF: ${href}`)
	}
    }, [href])

    return <Pressable style={styles.link} onPress={onPress}>{children}</Pressable>
};
const styles = StyleSheet.create({
    link: {
	fontVariant: ['small-caps']
    },
})
export default Link
